import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

// For notifications that can legitimately arrive in a quick burst (e.g.
// several visitors checking in within seconds of each other at a busy
// gate) — shows the first one as a normal toast, but if another for the
// same groupKey arrives while it's still live, replaces it with a single
// "N new notifications" toast instead of letting them stack up.
@Injectable({ providedIn: 'root' })
export class ToastGroupService {
  private groups = new Map<string, { count: number; toastId: number; timer: any }>();

  notify(toaster: ToastrService, message: string, title: string, groupKey: string, windowMs: number = 4000): void {
    const existing = this.groups.get(groupKey);
    if (existing) {
      clearTimeout(existing.timer);
      existing.count++;
      toaster.remove(existing.toastId);
      const combined = toaster.info(existing.count + ' new notifications', title);
      existing.toastId = combined.toastId;
      existing.timer = setTimeout(() => this.groups.delete(groupKey), windowMs);
      return;
    }
    const toastRef = toaster.info(message, title);
    const timer = setTimeout(() => this.groups.delete(groupKey), windowMs);
    this.groups.set(groupKey, { count: 1, toastId: toastRef.toastId, timer });
  }
}
